import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { MAIN_MENU_TRANSLATION_KEY } from "../constants";
var pt = /*#__PURE__*/_defineProperty({}, MAIN_MENU_TRANSLATION_KEY, {
  SEE_ALL: 'Ver tudo',
  // LeftMenu
  LEFT_MENU_TITLE: 'Menu',
  OPEN_MENU: 'Menu aberto',
  CATALOG_MENU_LABEL: 'Cursos',
  RESOURCES_MENU_LABEL: 'Recursos',
  DEGREES_MENU_LABEL: 'Microdegrees',
  PREMIUM_LANDING_LINK_LABEL: 'Para Pessoas',
  B2B_PLANS_LANDING_LINK_LABEL: 'Para negócios',
  HIGHER_EDUCATION_LABEL: 'Higher Education',
  B2B_LANDING_LINK_LABEL: 'Para Firmas',
  HELP_CENTER_LABEL: 'Central de ajuda',
  // CatalogMenu
  CATALOG_MENU_TITLE: 'Explora Crehana',
  // CatalogMenu - Categories
  CATALOG_SUBCATEGORIES_TITLE: 'Subcategorias',
  CATALOG_SOFTWARE_TITLE: 'Software',
  CATALOG_CATEGORIES_TITLE: 'Categorias',
  COURSE_COUNT: '{{count}} curso',
  COURSE_COUNT_plural: '{{count}} cursos',
  // CatalogMenu - NewCourses
  NEW_COURSES_TITLE: 'Novos lançamentos',
  NEW_COURSES_POPPER_TITLE: 'Novos lançamentos em Crehana',
  NEW_COURSES_SEE_ALL: 'Ver todos os novos cursos',
  // CatalogMenu - MicroDegrees
  MICRODEGREES_POPPER_TITLE: 'Nuestros diplomados',
  FULL_MICRODEGREE_TITLE: 'MicroDegree en {{title}}',
  FULL_BOOTCAMP_TITLE: 'Bootcamp de {{title}}',
  MONTH_COUNT: '{{count}} mes',
  MONTH_COUNT_plural: '{{count}} meses',
  MICRODEGREE_PARTNER_LABEL: 'Cocreado y certificado por {{partner}}',
  MICRODEGREE_SEE_DETAILS: 'Ver detalles del programa',
  // CatalogMenu - Academies
  ACADEMY_TITLE: 'Academias',
  ACADEMY_POPPER_TITLE: 'Conheça as nossas academias',
  FULL_ACADEMY_TITLE: '{{title}}',
  ACADEMY_COUNT: '{{count}} rota',
  ACADEMY_COUNT_plural: '{{count}} rotas',
  ACADEMIES_COUNT: '{{count}} Academia',
  ACADEMIES_COUNT_plural: '{{count}} Academias',
  ACADEMY_LEARNING_PATHS_COUNT: '{{count}} rota de aprendizagem',
  ACADEMY_LEARNING_PATHS_COUNT_plural: '{{count}} trilhas de aprendizagem',
  ACADEMY_TAG: 'Novo',
  // ResourcesMenu
  MENTOR_LANDING_LABEL: 'Mentorias',
  BLOG_LABEL: 'Blog',
  RESOURCES_TOOLS_LABEL: 'Ferramentas',
  COURSE_AGENDA_LABEL: 'Agenda de cursos',
  CREHANA_LIVE_LABEL: 'Ao vivo',
  // Search
  SEARCH_TITLE: 'Procurar',
  SEARCH_INPUT_HINT: 'Procurar cursos aqui',
  SEARCH_CLEAR: 'Limpar',
  // RightMenu
  USER_DASHBOARD_COURSES_LABEL: 'Meus cursos',
  USER_DASHBOARD_PRODUCTS_LABEL: 'Produtos',
  USER_DASHBOARD_SAVED_COURSES_LABEL: 'Meus salvos',
  B2B_DASHBOARD_LIST: 'Meus perfis',
  B2B_ADMIN_DASHBOARD_LABEL_SHORT: 'Administração',
  B2B_ADMIN_DASHBOARD_LABEL: 'Painel de administração',
  B2B_LEADER_DASHBOARD_LABEL_SHORT: 'Líder',
  B2B_LEADER_DASHBOARD_LABEL: 'Painel de líder',
  INBOX_LABEL: 'Converse com um mentor',
  INBOX_LABEL_FOR_MENTORS: 'Bate-papo de mentoria',
  SHOPPING_CART_LABEL: 'Carrinho de compras',
  NOTIFICATIONS_LABEL: 'Notificações',
  FEEDBACK_LABEL: 'Feedback',
  // Auth
  LOGIN_LABEL_SHORT: 'Ingressar',
  LOGIN_LABEL: 'Iniciar sessão',
  REGISTER_LABEL: 'Inscreva-se',
  // UserMenu
  USER_MENU_TITLE: 'Minha conta',
  LOGOUT: 'Fechar sessão',
  // DashboardMenu
  FAQS: 'FAQS',
  DASHBOARD_SEARCH_HINT: 'O que você procura no seu painel?',
  RENEWAL_ITEM_MESSAGE: 'Sua assinatura irá expirar em {{remainingDays}} dias!',
  RENEWAL_ITEM_CTA: 'Quero renovar',
  // Labels
  SEARCH_LABEL: 'Procurar',
  MESSAGE_LABEL: 'Hablar',
  // SwitchToOldHomeUser
  SWITCH_TO_OLD_HU_LABEL: 'Você está usando a nova versão do Crehana',
  SWITCH_TO_OLD_HU_CTA: 'Voltar para a versão antiga',
  // Blog menu
  DOWNLOADABLE_RESOURCES_LABEL: 'para download',
  BLOG_CATEGORIES_LINK_LABEL: 'categorias',
  LEFT_MENU_FOLLOW_US: 'Seguimos em',
  SEARCH_PLACEHOLDER: 'Pesquisar artigo, ebook, vídeo...',
  LEFT_MENU_CATEGORIES_VIEW_MORE: 'Ver mais categorias',
  LEFT_MENU_CATEGORIES_VIEW_LESS: 'Ver menos',
  //
  LEFT_MENU_SOLUTIONS: 'Soluções',
  SOLUTIONS_MENU_LEARNING_MANAGEMENT: 'Gerenciamento de aprendizagem',
  SOLUTIONS_MENU_E_LEARNING: 'E-learning',
  SOLUTIONS_MENU_E_LEARNING_DESCRIPTION: 'Acesse +1000 cursos, academias e orientação para sua equipe.',
  SOLUTIONS_MENU_ELEVATE_LMS: 'Elevate LMS',
  SOLUTIONS_MENU_ELEVATE_LMS_DESCRIPTION: 'Centralize seu plano de treinamento, conteúdo e aplicativos.',
  SOLUTIONS_MENU_SKILL_XP: 'Skill XP: Test de habilidades',
  SOLUTIONS_MENU_SKILL_XP_DESCRIPTION: 'Ele mede o nível atual de habilidades de cada pessoa.',
  SOLUTIONS_MENU_TALENT_MANAGEMENT: 'Gerenciamento de talentos',
  SOLUTIONS_MENU_DEVELOPMENT: 'Desenvolvimento',
  SOLUTIONS_MENU_DEVELOPMENT_DESCRIPTION: 'Desenvolva habilidades',
  SOLUTIONS_MENU_WORK_ENVIRONMENT: 'Ambiente de trabalho',
  SOLUTIONS_MENU_WORK_ENVIRONMENT_DESCRIPTION: 'Meça o clima de trabalho da sua empresa',
  SOLUTIONS_MENU_PERFORMANCE: 'Desempeño',
  SOLUTIONS_MENU_PERFORMANCE_DESCRIPTION: 'Gerencie e meça os objetivos de sua equipe com o negócio.',
  SOLUTIONS_MENU_ENGAGEMENT: 'Engagement',
  SOLUTIONS_MENU_ENGAGEMENT_DESCRIPTION: 'Ele gerencia a satisfação com os NPs, feedback e mais pesquisas.',
  // RightMenu > Productos
  PRODUCTS_TITLE: 'Produtos Crehana',
  PRODUCTS_RECOGNITION_TITLE: 'Agradecimentos',
  PRODUCTS_RECOGNITION_DESCRIPTION: 'Gerenciar medalhas e recompensas da empresa',
  PRODUCTS_PERFORMANCE_TITLE: 'Desempenho',
  PRODUCTS_PERFORMANCE_DESCRIPTION: 'Plano de desenvolvimento e gestão de objetivos',
  PRODUCTS_ENVIRONMENT_TITLE: 'Clima',
  PRODUCTS_RENVIRONMENT_DESCRIPTION: 'Medir cultura e satisfação',
  PRODUCTS_ELEARNING_TITLE: 'E-learning',
  PRODUCTS_ELEARNING_DESCRIPTION: 'Cursos, rotas e academias para suas equipes.',
  PRODUCTS_ANALYTICS_TITLE: 'Analítica',
  PRODUCTS_ANALYTICS_DESCRIPTION: 'Monitore seus processos e gere relatórios.',
  PRODUCTS_MANAGE_TITLE: 'Gerenciar',
  PRODUCTS_MANAGE_DESCRIPTION: 'Gerenciar usuários e configurações da empresa',
  PRODUCTS_TREND_FUTURE_TITLE: 'Futuro das Pessoas',
  PRODUCTS_TREND_FUTURE_DESCRIPTION: 'Artigos relevantes para o desenvolvimento profissional',
  PRODUCTS_TREND_AMAZING_TITLE: 'Pessoas incríveis',
  PRODUCTS_TREND_AMAZING_DESCRIPTION: 'Podcast com especialistas em desenvolvimento de pessoas'
});
export default pt;